import React, { JSX } from 'react';

type ProviderNextAvailableProps = {
  deptDays?: {
    [key: string]: string[];
  };
  deptId: string;
  providerId: string;
};

const ProviderNextAvailable = (
  props: ProviderNextAvailableProps
): JSX.Element => {
  const { deptDays, deptId, providerId } = props;

  const createLocalDate = (dateString: string) => {
    const [year, month, day] = dateString.split('-').map(Number);
    const date = new Date(year, month - 1, day, 12, 0, 0);
    return date;
  };

  return (
    <div
      className="profile-scheduling next-appts"
      data-module="ProfileSchedulingFactory"
      epic-provider-id={providerId}
      epic-dept-id={deptId}
    >
      {deptDays && deptDays[deptId]?.length > 0 && (
        <div className="appt-dates">
          <p className="dates-label">
            Next available new patient appointments:
          </p>
          <ul className="next-dates">
            {deptDays[deptId].map((date, index) => {
              return (
                <li className="date" key={`data-${index}`}>
                  {createLocalDate(date).toLocaleDateString('en-US', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })}
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ProviderNextAvailable;
